__webpack_require__.p = "/shared-mailboxes-walkthrough/referrals-hub/";